import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Home from "./pages/Home";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import SubmitQuery from "./pages/SubmitQuery";
import QueryDetail from "./pages/QueryDetail";
import ExpertRegister from "./pages/ExpertRegister";
import ExpertDashboard from "./pages/ExpertDashboard";
import AdminPanel from "./pages/AdminPanel";

function ProtectedRoute({ children, role }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-gray-500" data-testid="auth-loading">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/become-expert" element={<ExpertRegister />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/submit-query" element={<ProtectedRoute><SubmitQuery /></ProtectedRoute>} />
            <Route path="/query/:id" element={<ProtectedRoute><QueryDetail /></ProtectedRoute>} />
            <Route path="/expert/dashboard" element={<ProtectedRoute role="expert"><ExpertDashboard /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute role="admin"><AdminPanel /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
